import styled from 'styled-components';

export const FileList = styled.div`
  margin-top: 8px;
`;
